(function () {
  const initSlider = () => {
    const slider = document.querySelector(".categories-collections");
    const scrollbar = slider?.querySelector(".swiper-scrollbar");
    const filterSlider = document.querySelector(".categories-filters");
    let slidesPerView = "auto";

    const activeSlide = slider?.querySelector(".active-subcollection");
    const activeSlideIndex = Array.from(slider?.querySelectorAll(".swiper-slide") || []).indexOf(activeSlide);

    let activeFilterSlideIndex = 0;

    if (filterSlider) {
      const activeFilterSlide = filterSlider.querySelector(".active-filter");
      activeFilterSlideIndex = Array.from(filterSlider.querySelectorAll(".categorie-filter__link")).indexOf(activeFilterSlide);
    }

    if (slider?.closest(".categories-pdp")) {
      slidesPerView = window.innerWidth < 749 ? 1 : 3;
    }

    if (slider) {
      let swiperParams = {
        slidesPerView: slidesPerView,
        spaceBetween: 12,
        initialSlide: activeSlideIndex >= 0 ? activeSlideIndex : 0, 
        breakpoints: {
          990: {
            slidesPerView: slidesPerView,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next", 
          prevEl: ".swiper-button-prev",
        },
        scrollbar: {
          el: scrollbar,
          hide: false,
          draggable: true,
        },
        freeMode: true, 
        simulateTouch: true, 
        touchEventsTarget: "container", 
        mousewheel: {
          forceToAxis: true, 
          sensitivity: 0.5, 
        },
      };
      new Swiper(slider, swiperParams); 
    }

    if (filterSlider) {
      let filterSwiperParams = {
        slidesPerView: "auto",
        initialSlide: activeFilterSlideIndex >= 0 ? activeFilterSlideIndex : 0,
        spaceBetween: 28,
        breakpoints: {
          990: {
            slidesPerView: "auto",
            spaceBetween: 48,
          },
        },
        freeMode: true, 
        simulateTouch: true, 
        touchEventsTarget: "container",
        mousewheel: {
          forceToAxis: true,
          sensitivity: 0.5,
        },
      };

      new Swiper(filterSlider, filterSwiperParams);
    }
  };

  initSlider();
  document.addEventListener("shopify:section:load", function (event) {
    initSlider();
  });
})();
